import { render, staticRenderFns } from "./templateCustom.vue?vue&type=template&id=180319e6&scoped=true&"
import script from "./templateCustom.vue?vue&type=script&lang=ts&"
export * from "./templateCustom.vue?vue&type=script&lang=ts&"
import style0 from "./templateCustom.vue?vue&type=style&index=0&id=180319e6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180319e6",
  null
  
)

export default component.exports